import React, { createContext, useMemo, useState } from 'react';

interface AuthContextType {
  user: string;
  setUser: React.Dispatch<React.SetStateAction<string>>;
}

const initialAuth = { user: '', setUser: () => '' };

export const AuthContext = createContext<AuthContextType>(initialAuth);

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<string>('');

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
    }),
    [user, setUser]
  );

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}
